export const SET_SELECTED_PARKING_PASS_IDS = 'set-selected-parking-pass-ids';
const setSelectedParkingPassIDs = (selectedParkingPassIds) => ({ type: SET_SELECTED_PARKING_PASS_IDS, payload: { selectedParkingPassIds }});
export default setSelectedParkingPassIDs;
